import {
    Document,
    View,
    Page,
    Text,
    PDFViewer,
    Image,
  } from "@react-pdf/renderer";
  import imgHt from "../../imagenes/imgHt.png";
  import { format } from "date-fns";

  export default function InformePresupuestoPDF({docAux, sumaTotal}){
    let date = format(new Date(), "yyyy/MM/dd");

    console.log(docAux);
    console.log(sumaTotal);
    
    

    return(
      <PDFViewer style={{ width: "118vh", height: "90vh" }}>
        <Document>
          <Page size="A4" style={{display:"flex"}}>
          
            <View style={{display:"flex"}}>
            <View
                  style={{
                    widt: "200px",
                    height: "80px",
                    flexDirection: "row",
                    justifyContent: "space-around",
                    marginTop: "10px"                    
                  }}
                 >
                    
                    <Image
                      href={imgHt}
                      style={{ width: "100px", height: "60px" }}
                    />
                    <View style={{ marginLeft: "11px", marginTop: "10px" }}>                     
                      <Text style={{ fontSize: "9pt" }}>Grupo HT</Text>
                      <Text style={{ fontSize: "9pt" }}>Pedro Lozano 5066</Text>
                      <Text style={{ fontSize: "9pt" }}>CABA</Text>
                      <Text style={{ fontSize: "9pt" }}>Argentina</Text>
                      <Text style={{ fontSize: "9pt" }}>Tel: 15-57619270</Text>
                      <Text style={{ fontSize: "9pt" }}>CUIT: </Text>
                    </View>
                </View>
                <View style={{textAlign: "center"}}>
                  <Text style={{fontSize: "14px"}}>Informe Presupuesto</Text>
                </View>
                <View style={{flexDirection: "row", fontSize: "10pt", marginVertical:"10px"}}>
                  <Text style={{width: "40px", textAlign:"center"}}>Doc N°</Text>
                  <Text style={{width:"200px"}}>Cliente</Text>
                  <Text style={{width:"140px"}}>Domicilio Evento</Text>
                  <Text style={{width:"70px", textAlign:"center"}}>Fecha Salida</Text>
                  <Text style={{width:"70px", textAlign:"center"}}>Fecha Entrada</Text>
                  <Text style={{width:"70px", textAlign:"center"}}>Total Doc</Text>
                </View>
                <View>
                  {docAux.map(e=> {
                    return (
                    <View style={{flexDirection: "row", fontSize: "10pt"}}>
                      <Text style={{width: "40px", textAlign: "center", borderBottom: "1px"}}>{e.numberDocument}</Text>
                      <Text style={{width: "200px", borderBottom: "1px"}}>{e.client_id.nameCompany}</Text>
                      <Text style={{width: "140px", borderBottom: "1px"}}>{e.addressEvent}</Text>
                      <Text style={{width: "70px", borderBottom: "1px", textAlign:"center"}}>{format(new Date(e.dateSend), "dd/MM/yyyy")}</Text>
                      <Text style={{width: "70px", borderBottom: "1px", textAlign:"center"}}>{format(new Date(e.dateReception), "dd/MM/yyyy")}</Text>
                      <Text style={{width: "70px", textAlign:"right", paddingRight: "5px", borderBottom: "1px"}}>{e.totalCoeficiente}</Text>
                    </View>
                    )
                  })}
                </View>
                <View style={{flexDirection:"row", justifyContent:"space-between", fontSize:"14pt", marginTop:"10px", marginHorizontal:"10px"}}>
                  <Text>Total</Text>
                  <Text>{sumaTotal}</Text>
                </View>
              
            </View>            
          </Page>
        </Document>
      </PDFViewer>      
    )
  }